<template>
  <section class="sc" data-test="settings-card">
    <div v-if="title" class="sc__head">
      <div class="sc__title">{{ title }}</div>
      <div v-if="description" class="sc__desc">{{ description }}</div>
    </div>
    <div class="sc__body" :class="{ 'sc__body--titled': title }">
      <slot />
    </div>
  </section>
</template>

<script>
/**
 * The white card that groups a few settings rows (design frames 1k-1o: "Procedures", "Board", "Card",
 * "Sender"...). A title is optional. ⛔ The card never clips: nothing here cuts its content, so a picker's list can open
 * past its bottom edge (the sheet body is the only scroll container).
 *
 * Presentational. ⛔ No prop named patNum / siteID / loading / allSettings / isSuperAdmin / userID.
 */
export default {
  name: 'SettingsCard',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '../workflow-tokens';

.sc {
  @include fu-card(14px);
  box-shadow: $fu-shadow-xs;
}

.sc__head { padding: 16px 20px 0; }

.sc__title {
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
  color: $fu-text;
}

.sc__desc {
  margin-top: 3px;
  font-size: 13px;
  line-height: 1.45;
  color: $fu-neutral-500;
}

.sc__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 18px 20px 20px;

  &--titled { padding: 14px 20px 20px; }
}
</style>
